var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"node",style:({
    top: _vm.y + 'px',
    left: _vm.x + 'px'
  }),on:{"click":function (e) { return _vm.$emit('click', e); }}},[_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }